module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/RU-6983b5ff3775379666461bcf34b4c9c7.png";